// eslint-disable-next-line @typescript-eslint/no-unused-vars, unused-imports/no-unused-imports-ts
import { h } from '@stencil/core';

const ActionLogo = () => (
    <svg width="16" height="16" class="" viewBox="0 0 18 18" data-testid="2019-logo-icon">
        <circle cx="10" cy="10" r="6" fill="#F7F8FD"></circle>
        <path
            d="M8.74 0a8.74 8.74 0 110 17.481A8.74 8.74 0 018.74 0zm3.668 5.824a.644.644 0 00-.903 0L7.35 9.917 5.977 8.564a.644.644 0 00-.904 0l-.608.599a.644.644 0 000 .917L6.9 12.477c.25.247.652.247.903 0l5.214-5.137a.644.644 0 000-.917z"
            fill="#00C358"
            fill-rule="nonzero"
        ></path>
    </svg>
);

export default ActionLogo;
